<div class="page">
  <h1 class="title">
    <span>#{{ orderId }}</span>
    <span> - {{ projectType }} </span>
    <span> - {{ projectDescription }} </span>
    <span>- {{ "order-details.title" | translate }}</span>
  </h1>

  @if (this.shouldShowRequestedItemsDirectly()) {
    <div>
      <app-requested-items-component
           [isRequester]="isRequester"
           [isRejected]="isRejected"
           [isCancelled]="isCancelled"
           [cancelledJustification]="cancelationJustification"
           [rejectionJustification]="rejectionJustification"
           [generalRemarks]="generalRemarks"
           [itemsData]="itemsData">
      </app-requested-items-component>
    </div>
  } @else {
    <div fxLayout="column">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)" animationDuration="100ms">
        <mat-tab label="{{'order-details.requestedItems' | translate}}">
          <ng-template matTabContent>
            <div class="tab-spacing">
              <app-requested-items-component
              [isCancelled]="isCancelled"
              [isRejected]="isRejected"
              [cancelledJustification]="cancelationJustification"
              [rejectionJustification]="rejectionJustification"
              [generalRemarks]="generalRemarks"
              [itemsData]="itemsData">
              </app-requested-items-component>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab label="{{'general.budget' | translate}}">
          <ng-template matTabContent>
            <div class="tab-spacing">
              <app-budgets-component
              [(supplierIds)]="selectedSupplierIds"
              (budgetsPendingApprovalChange)="handleBudgetsPendingApprovalChange($event)"
              (supplierIdsChange)="onSuppliersSelected($event)">
            </app-budgets-component>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</div>

<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
